import { Link, useLocation } from 'react-router-dom';
import './styles.scss';

const ProductSidebar = ({ title, data }) => {
    const location = useLocation();
    return (
        <div className="product-sidebar">
            <div className="description-demibold product-sidebar__title">{title}</div>
            <div className="product-sidebar-cards">
                {data?.map((item, index) => (
                    <Link
                        to={`${location.pathname.replace(/\/[^/]+$/, `/${item?.slug}`)}`}
                        key={index}
                        className="product-sidebar-card"
                    >
                        <img src={item.icon} alt={item.title} />
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default ProductSidebar;
